// extracted by mini-css-extract-plugin
export default {"course":"CourseItem_course__3SLjk"};